module.exports = __webpack_public_path__ + "img/ag1-logo.6b45ee3a.png";